module.exports = __webpack_public_path__ + "static/media/logo_4.f00353c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_4.png
// module id = 787
// module chunks = 0